/**
 * O fuso de um ambiente — o que diz que dia é "hoje" nas fórmulas. Ver o `System.timeZone` do
 * servidor, que é quem o aplica.
 */

/**
 * O fuso de quem não escolheu nenhum: o dos ambientes que nasceram antes do campo. O mesmo padrão
 * do `clockAt` do servidor (lunedi/src/formula/values.ts) — a cópia é só para a tela dizer qual é.
 */
export const DEFAULT_TIME_ZONE = 'America/Sao_Paulo'

/** O fuso que vale para o ambiente: o escolhido, ou o padrão no que nasceu antes do campo. */
export function timeZoneOf(workspace: { timeZone?: string }): string {
    return workspace.timeZone || DEFAULT_TIME_ZONE
}

/** O fuso de quem está usando o navegador — o ponto de partida de um ambiente novo. */
export function browserTimeZone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || DEFAULT_TIME_ZONE
}

/**
 * Os fusos que o navegador conhece, pelo nome do IANA — os mesmos que o `Intl` do servidor aceita.
 * Navegador antigo, sem a lista, oferece ao menos o dele e o padrão.
 */
export function timeZoneOptions(): string[] {
    const supported = (Intl as unknown as { supportedValuesOf?: (key: string) => string[] }).supportedValuesOf
    return supported ? supported('timeZone') : [...new Set([browserTimeZone(), DEFAULT_TIME_ZONE])]
}
